import { createAction, createSlice } from '@reduxjs/toolkit';

import { initialStore } from '../initial-store';

export const getBlackList = createAction('blackList/GET_LIST');

const blackListSlice = createSlice({
  initialState: initialStore.blackListPage,
  name: 'blackListPage',
  reducers: {
    removeBlackList: (state, { payload }) => {
      state.data = state.data.filter((item) => item.id !== payload.id);
    },
    setBlackList: (state, { payload }) => {
      const { count, result } = payload;
      state.data = result;
      state.count = count;
      state.isLoading = false;
    },
    setLoading: (state, { payload }) => {
      state.isLoading = payload;
    },
    updateBlackList: (state, { payload }) => {
      state.data = state.data.map((item) => {
        if (item.id === payload.id) {
          return payload;
        }
        return item;
      });
    }
  }
});

export const { removeBlackList, setBlackList, setLoading, updateBlackList } =
  blackListSlice.actions;

export const { reducer } = blackListSlice;
